import {FaFacebookF, FaInstagram,FaLinkedinIn,FaWhatsapp,FaGithub, FaTwitter} from "react-icons/fa";

const HomeSocial = [
    {
        id: 1,
        iconName : <FaFacebookF/>,
        iconLink : "https://www.facebook.com/Rishika-Jain/"
    },
    {
        id: 2,
        iconName : <FaInstagram/>,
        iconLink : "https://www.instagram.com/rishika4444/"
    },
        {
        id: 3,
        iconName : <FaLinkedinIn/>,
        iconLink : "https://www.linkedin.com/in/rishika-jain-1a583a203"
    },
    {
        id: 4,
        iconName : <FaGithub/>,
        iconLink : "https://github.com/rjrishika"
    },
    {
        id : 5,
        iconName: <FaTwitter/>,
        iconLink: "https://twitter.com/44Rishika"
    }
    
]

export {HomeSocial}